import { colors, CustomTheme } from '../../lib/utils/CustomTheme';
const { desktop } = CustomTheme.mediaQueries;
export const pageStyle = {
    marginBottom: '1.5rem', // 24px to rem
    backgroundColor: CustomTheme.container.secondary,
    height: '100%',
    '.buttonWrapper': {
        display: 'flex',
        flexDirection: 'column',
        margin: '0 1.5rem', // 24px to rem
        gap: '0.5rem', // 8px to rem
        button: {
            '&:hover': {
                '&.cancel': {
                    background: 'white',
                },
                '&.next': {
                    background: colors.lightBlue,
                },
                '&:active': {
                    color: 'white',
                    background: colors.darkBlue,
                    borderColor: colors.darkBlue,
                },
            },
            '&:disabled': {
                background: colors.lightBlue,
                color: 'black',
            },
        },
    },
    '.heroWrapper': {
        display: 'none',
    },
    [desktop]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        backgroundColor: CustomTheme.container.primary,
        '.formWrapper': {
            marginBottom: '1.5rem',
        },
        '.buttonWrapper': {
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            maxWidth: '21.75rem', // 316px to rem
            margin: '0 2.5rem', // 40px to rem
            gap: '1rem', // 16px to rem
        },
        '.heroWrapper': {
            backgroundColor: CustomTheme.container.secondary,
            display: 'flex',
            flexDirection: 'column',
            placeItems: 'center',
            textAlign: 'center',
            img: {
                marginTop: '20svh',
                marginBottom: '1.125rem', // 18px to rem
                width: '18rem', // 288px to rem
                height: '18.75rem', // 300px to rem
            },
            h2: {
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '2rem', // 32px to rem
                '.light': {
                    fontFamily: 'Avenir',
                    fontWeight: 300,
                },
            },
            h6: {
                maxWidth: '19.375rem', // 310px to rem
            },
        },
    },
};
